// extracted by mini-css-extract-plugin
module.exports = {"box":"Coin_box__3CsRP","coin":"Coin_coin__2bhWZ","spin":"Coin_spin__2A2TL"};